import { readGroupFromStore, readActiveGroupIdFromStore } from '../group-store'

function getActiveGroup() {
  const activeGroupId = readActiveGroupIdFromStore()
  return readGroupFromStore(activeGroupId)
}

export { getActiveGroup }